import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DateState {
  selectedDate: string;
}

const initialState: DateState = {
  selectedDate: new Date().toISOString().split("T")[0], // Use empty string as default instead of null
};

const dateSlice = createSlice({
  name: "date",
  initialState,
  reducers: {
    ModGridcoSelectedDate: (state, action: PayloadAction<string>) => {
      state.selectedDate = action.payload;
    },
  },
});

export const { ModGridcoSelectedDate } = dateSlice.actions;
export default dateSlice.reducer;
